import { APP_ID, APP_INITIALIZER, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app.component';

import { SystemModule } from './system/system.module';
import { LanguageService } from './services/language.service';
import { JSProxyService } from './services/jsproxy.service';
import { HTTPErrorInterceptor } from './services/httperrors.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieService } from "./services/cookie.service";
import { UsersService } from "./services/users.service";
import { CommandsService } from "./services/commands.service";
import { DialogService } from "./services/dialog.service";
import { ExcelService } from "./services/ExcelService";
import { SettingsService } from "./services/settings.service";
import { ConverterService } from "./services/converter.service";
import { AuthGuard } from './system/AuthGuard';
import { DriversService } from "./services/drivers.service";
import { KeysService } from "./services/keys.service";
import { ObjectsService } from "./services/objects.service";
import { TasksService } from "./services/tasks.service";
import { ZoneService } from "./services/zones.service";
import { ShiftsService } from "./services/shifts.service";
import { RoutesService } from "./services/routes.service";
import { RacesService } from "./services/races.service";
import { NotificationsService } from './services/notifications.service';
import { ServiceTaskService } from './services/servicetask.service';
import { CompletedWorksService } from './services/completedworks.service';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { SyncService } from "./services/sync.service";
import { DiagnosticsService } from "./services/diagnostics.service";
import { ImageService } from './services/image.service';
import { ReportTemplateService } from './services/reporttemplate.service';
import { CompaniesService } from './services/companies.service';
import { ContainersService } from './services/containers.service';
import { MobileSystemComponent } from './system/mobile-system/mobile-system.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const routes: Routes = [
  //{path: '', redirectTo: '/tracking', pathMatch: 'full'}
]

export function initUser(usersService: UsersService): () => Promise<any> {
  return (): Promise<any> => {
    return new Promise((resolve, reject) => {
      usersService.initializeUser();
      usersService.onInit.subscribe((res) => {
        resolve(res);
      });
    });
  };
}

export function waitPreinit() {
  return () => {
    const p = (window as any).__PREINIT__;
    return typeof p?.then === 'function' ? p : null;
  };
}


@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent
  ], imports: [CommonModule,
    //ServerModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, {}),
    SystemModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: false,
      progressBar: true,
      closeButton: true,
      tapToDismiss: true,
      autoDismiss: true,
      maxOpened: 10
    })], providers: [
      { provide: APP_INITIALIZER, useFactory: waitPreinit, multi: true },
      LanguageService,
      JSProxyService,
      { provide: HTTP_INTERCEPTORS, useClass: HTTPErrorInterceptor, multi: true },
      CookieService,
      UsersService,
      CommandsService,
      CompaniesService,
      ExcelService,
      SettingsService,
      DialogService,
      ConverterService,
      AuthGuard,
      DriversService,
      KeysService,
      ObjectsService,
      ContainersService,
      TasksService,
      ZoneService,
      ShiftsService,
      RoutesService,
      RacesService,
      NotificationsService,
      SyncService,
      {
        provide: APP_INITIALIZER,
        useFactory: initUser,
        multi: true,
        deps: [UsersService]
      },
      ServiceTaskService,
      CompletedWorksService,
      DiagnosticsService,
      ImageService,
      ReportTemplateService,
      CompaniesService,
      provideHttpClient(withInterceptorsFromDi()),
      provideClientHydration(),
      provideAnimationsAsync(),
      { provide: APP_ID, useValue: 'ng-cli-universal' }, // optional replacement for the old appId
      providePrimeNG({
        theme: {
          preset: Aura,                      // or Aura / Nora / Material / Saga
          options: { darkModeSelector: false } // force light if needed
        }
      }),
    ]
})
export class AppModule {
}
